(function ($, Cobalt, undefined) {
	var _tabGroupCounter = 0;

	Cobalt.Tabs = {

        priority: 1,
		initialize: function () {

			// This is our own system, which maintains tab state between page loads
			Cobalt.runOnHtmlInsert(Cobalt.Tabs.addDelayedLoadingSupport);
			Cobalt.runOnHtmlInsert(Cobalt.Tabs.addTabSupport);

			// This uses the jQuery tab system
			Cobalt.runOnHtmlInsert(Cobalt.Tabs.addLegacyTabSupport);
		},
		addDelayedLoadingSupport: function ($parent) {
		    $parent.find('.j-tab-content').each(function () {
				var $tabPanel = $(this);

				var hasDelayLoadPanel = $tabPanel.find('.listing[data-delay-load-url]').length > 0;

				if (hasDelayLoadPanel) {
				    var tabs = $(".j-tab-search").find("ul.tabbed-tabs:first > li");
					tabs.each(function (i, val) {
						$(val).bind('tabsselect', function (content, tab) {
							var tab = $(tab);
							if (tab.length > 0) {							    
								var listing = tab.find(".listing");
								if (listing.length > 0) {
									var delayLoadUrl = listing.attr('data-delay-load-url');
									if (delayLoadUrl != undefined && delayLoadUrl != '') {
										var delayLoadDone = listing.attr('data-delay-load-done');
										if (delayLoadDone == undefined || !delayLoadDone) {
										    $tabPanel.mask();
											$.get(delayLoadUrl, null, function (html) {
												listing.find('tbody').html(html)

												Cobalt.triggerHtmlInsert(listing.parent());

												listing.attr('data-delay-load-done', true);

												$tabPanel.unmask();
											});
										}
									}
								}
							}
						});
					});
				}
			});
		},
		addLegacyTabSupport: function ($parent) {
			$parent.find(".tab-container").each(function () {
				$("div.tab-tabs-container").children("span.tab.tab-selected").each(function () {
					var dataTabID = $(this).attr("data-tab-id");
					$("div.tab-content-container").children("div.tab-content#" + dataTabID).show();
				});

				$("span.tab").click(function () {
					var dataTabID = $(this).attr("data-tab-id");
					$(this).siblings().removeClass("tab-selected");
					$(this).addClass("tab-selected");

					$("div.tab-content-container > div.tab-content").hide();
					$("div.tab-content-container > div.tab-content#" + dataTabID).show();

					return false;
				});
			});
		},
		addTabSupport: function ($parent) {

			$parent.find(".tabbed-container").each(function () {

				var container = $(this);
				var $tabs = container.find("ul.tabbed-tabs:first > li");
				if (container[0].tabsInitialized || $tabs.length == 0) {
					return;
				}

				// Prevent a tab container from being initialized over and over
				container[0].tabsInitialized = true;
				var tabsetID = container[0].id || ("t" + (++_tabGroupCounter));

				var currentTabID = null;
				var useViewState = !$(this).hasClass("no-view-state");

				// Setup the available view states
				if (useViewState) {
					var availableViewStates = [];
					for (var i = 0; i < $tabs.length; i++) {
						availableViewStates.push($($tabs[i].children[0]).attr("href").replace("#", ""));
					}

					// Register the view state, for page-to-page preservation
					var viewState = Cobalt.ViewStateManager.getViewState(tabsetID);
				}

				// First try to get the current tab from the view State
				if (viewState != null && viewState.value != null && viewState.value != undefined && availableViewStates.indexOf(viewState.value) > -1) {
					currentTabID = "#tab-" + viewState.value;
					if ($tabs.find("a[href=#" + viewState.value + "]").length == 0) {
						currentTabID = null;
					}
				}
				else {
					var $selectedTab = $tabs.filter(".selected");
					if ($selectedTab.length == 0) {
						$selectedTab = $($tabs[0]);
					}
					var href = $selectedTab.find("a").attr("href");
					if (href.length > 0) {
						currentTabID = "#tab-" + href.substring(1);
					}
				}


				var tabbedPager = container.find(".tabbed-pager");
				if (tabbedPager.length > 0) {
					Cobalt.Tabs.setupTabPager(tabbedPager, $tabs, currentTabID, container, viewState);
				}

				$tabs.each(function () {
					var $anchor = $(this).find("a");
					var id = $(this).find("a").attr("href");
					$(this).find("a").removeAttr("href")
					id = id.substring(id.indexOf("#") + 1);
					var contentID = "#tab-" + id;
					var content = $(container).find(contentID);
					var eventData = { viewState: viewState, tab: $(this), tabID: id, content: content, tabs: $tabs };
					if (!$(this).hasClass('tab-disabled')) {
					    $(this).bind('click', eventData, Cobalt.Tabs.selectTab);
					}
					$(this).data("tabContent", content);
					if (contentID == currentTabID) {
						Cobalt.Tabs.selectTab({ data: eventData, isFirstLoad: true });
					}
				});
			});
		},
		setupTabPager: function (tabbedPager, tabs, currentTabID, tab) {
			var nextTabButton = tabbedPager.find(".tabbed-pager-next");
			var previousTabButton = tabbedPager.find(".tabbed-pager-prev");
			if (nextTabButton.length > 0 && previousTabButton.length > 0) {
				var tabIDs = [];
				for (var i = 0; i < tabs.length; i++) {
					var id = $(tabs[i]).find("a").attr("href");
					id = id.substring(id.indexOf("#") + 1);
					tabIDs.push("#tab-" + id);
				}
				var currentTabIndex = tabIDs.indexOf(currentTabID);
				var nextTabIndex = currentTabIndex + 1;
				var previousTabIndex = currentTabIndex - 1;

				if (nextTabIndex >= tabIDs.length) {
					nextTabButton.addClass("disabled");
				} else {
					nextTabButton.removeClass("disabled");
				}

				if (previousTabIndex <= 0) {
					previousTabButton.addClass("disabled");
				} else {
					previousTabButton.removeClass("disabled");
				}

				var eventData =
				{
					tabs: tabs,
					nextTabIndex: nextTabIndex,
					previousTabIndex: previousTabIndex,
					nextTabButton: nextTabButton,
					previousTabButton: previousTabButton
				};
				
				nextTabButton.bind("click", eventData, Cobalt.Tabs.selectNextTab);
				previousTabButton.bind("click", eventData, Cobalt.Tabs.selectPreviousTab);
			}
		},
		selectNextTab: function (event) {
			event.preventDefault();
			var nextTab = $(event.data.tabs[event.data.nextTabIndex]);
			if (nextTab.length > 0) {
				nextTab.click();
				event.data.nextTabButton.unbind("click");
				event.data.previousTabButton.unbind("click");

				event.data.nextTabIndex++;
				event.data.previousTabIndex++;

				event.data.nextTabButton.bind("click", event.data, Cobalt.Tabs.selectNextTab);
				event.data.previousTabButton.bind("click", event.data, Cobalt.Tabs.selectPreviousTab);

				if (event.data.nextTabIndex >= event.data.tabs.length) {
					event.data.nextTabButton.addClass("disabled");
				} else {
					event.data.nextTabButton.removeClass("disabled");
				}

				if (event.data.previousTabIndex >= 0) {
					event.data.previousTabButton.removeClass("disabled");
				}
			}
		},
		selectPreviousTab: function (event) {
			event.preventDefault();
			var previousTab = $(event.data.tabs[event.data.previousTabIndex]);
			if (previousTab.length > 0) {
				previousTab.click();
				event.data.nextTabButton.unbind("click");
				event.data.previousTabButton.unbind("click");

				event.data.nextTabIndex--;
				event.data.previousTabIndex--;

				event.data.previousTabButton.bind("click", event.data, Cobalt.Tabs.selectPreviousTab);
				event.data.nextTabButton.bind("click", event.data, Cobalt.Tabs.selectNextTab);

				if (event.data.previousTabIndex < 0) {
					event.data.previousTabButton.addClass("disabled");
				} else {
					event.data.previousTabButton.removeClass("disabled");
				}

				if (event.data.nextTabIndex < event.data.tabs.length) {
					event.data.nextTabButton.removeClass("disabled");
				}
			}
		},
		selectTab: function (event) {
			var content = event.data.content;
			var tab = event.data.tab;
			var tabID = event.data.tabID;
			var tabs = event.data.tabs;
			var viewState = event.data.viewState;
			if (viewState != null && !event.isFirstLoad && !$(tab).hasClass("first-load")) {
				viewState.setValue(tabID);
			}
			$(tab).removeClass("first-load");
			Cobalt.Tabs.hideContent(content);
			tabs.removeClass("selected");
			tab.addClass("selected");
			Cobalt.Tabs.showContent(content);
			tab.trigger("tabsselect", content, tab);
		},
		showContent: function (content) {
			content.show();
		},
		hideContent: function (content) {
			content.siblings().hide();
		}
	};
})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Tabs.js